import { useCallback, useEffect, useState } from 'react'
import React from 'react'

import { AxiosResponse } from 'axios'
import { Card } from 'components'
import { useAuth, useLoading, useModal, useToggle } from 'hooks'
import { useMovement } from 'hooks'
import moment from 'moment'
import { ErrorList } from 'pages/Supplier/MovMensal/types'
import {
  MovimentacaoMensalServices,
  Value as ErrorsList
} from 'services/Supplier/MovMensal'
import { COLORS, FORMAT, SPACING } from 'utils'

import {
  Entity,
  ResponseGetParametrizacaoEfeitvo,
  CamposVisaoTotal
} from '../../types'
import {
  CompetenciaAtual,
  CompetenciaIndividual,
  OrientacaoTemplateButtons,
  VisaoTotal
} from './components'
import { ModalRelatorioErros } from './components/CompetenciaIndividual/components'

export interface IMovimentacaoMensal {
  handleTab: (_: any, _newValue: number) => void
  handleCompetencia: (competencia: string) => void
}

export interface IMobilizacoes {
  flComMob: boolean
  flCompartilhado: boolean
  flSemMob: boolean
}

const MovimentacaoMensal: React.FC<IMovimentacaoMensal> = ({ handleTab }) => {
  const {
    setIsAnalista,
    setIsContraparte,
    setParametrization,
    selectedMovement,
    handleError,
    setMovState,
    setDataAtuacaoInvalida,
    dataAtuacaoInvalida,
    handleBlock,
    movState,
    competenciaSelecionada,
    blockTotalVision,
    isContraparte,
    isAnalista,
    handleChangeMobilizacao,
    setBlockVerifyIndividual,
    blockIndividualVision
    // isSemMobilizacao: isSemMobContext,
    // isComMobilizacao: isComMobContext
  } = useMovement()

  const { allDatadescripted, user } = useAuth()
  const { showModal } = useModal()
  const { setLoading, loading } = useLoading()
  const { setLoadingMessage, loadingMessage } = useLoading()
  const [modalErrorsList, toggleModalErrorsList] = useToggle()

  const [errorList, setErrorList] = useState<ErrorList[]>()
  const [, setParamEfetivo] = useState<
    ResponseGetParametrizacaoEfeitvo | undefined
  >(null)

  const diaAtual = new Date().getDate()
  const [isDataValida, setIsDataValida] = useState(false)

  const [isAutonomo, setIsAutonomo] = useState(false)
  const [simClicked, setSimClicked] = useState(false)
  const [modalSimClick, setModalSimClick] = useState<() => void>()
  const [modalNaoClick, setModalNaoClick] = useState<() => void>()
  const [isRequest, setIsRequest] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showModalAfterLoading, setShowModalAfterLoading] = useState<boolean>(false)
  const [ShowModalAfterLoadingConsolidacao, setShowModalAfterLoadingConsolidacao] = useState<boolean>(false)
  const [dataInicioModal, setDataInicioModal] = useState('')
  const [dataFimModal, setDataFimModal] = useState('')

  const [consolidacaoFechada, setConsolidacaoFechada] = useState<boolean>(false);

  const handleResponseParams = (
    response: AxiosResponse<ResponseGetParametrizacaoEfeitvo[]>
  ) => {
    if (response.status !== 200)
      throw new Error('Não foi possivel obter parametrização.')
    setParametrization(response.data[0])
    return response.data[0]
  }
  let dataInicio
  let dataFim
  const handleParams = async (params: ResponseGetParametrizacaoEfeitvo) => {
    if (allDatadescripted.Perfil === 'Fornecedor') {
      //INICIALIZA AS DATAS SE O USURARIO LOGADO FOR FORNECEDOR
      dataInicio = params?.dsInicioFechamentoFornecedorContraparte
      dataFim = params?.dsFimFechamentoFornecedorContraparte
    }
    if (user.PerfilUsuarioId === 6) {
      setIsAnalista(false)
      setIsContraparte(true)
      dataInicio = params?.dsInicioFechamentoFornecedorContraparte
      dataFim = params?.dsFimFechamentoFornecedorContraparte
    } else if (allDatadescripted.Perfil === 'Csn') {
      //BUSCA CONTRATO ATUAL
      const responseContrato =
        await MovimentacaoMensalServices().getContratoMovimentacaoMensal(
          selectedMovement?.contratoId
        )

      if (responseContrato.status !== 200)
        throw new Error('Erro obter dados contrato.')

      if (
        user?.IdUsuario === responseContrato?.data?.contraparteUsuarioId ||
        responseContrato?.data?.contraparteSub?.includes(user.IdUsuario) //NAO SEI SE VAI SER POR ID LISTA DE SUBSTITUTOS
      ) {
        //INICIALIZA AS DATAS SE O USURARIO LOGADO FOR CONTRAPARTE
        setIsAnalista(false)
        setIsContraparte(true)
        dataInicio = params?.dsInicioFechamentoFornecedorContraparte
        dataFim = params?.dsFimFechamentoFornecedorContraparte
      } else {
        //INICIALIZA AS DATAS SE O USURARIO LOGADO FOR ANALISTA
        setIsAnalista(true)
        setIsContraparte(false)
        dataInicio = params?.dsInicioFechamentoAnalista
        dataFim = params?.dsFimFechamentoAnalista
      }
    }
    // VERIFICACAO DAS DATAS PARAMETRIZACAO COM ATUAL
    // EXECUCAO DE CODIGOS PARA LIBERAR EDIÇÂO
    const isValida = +dataInicio <= diaAtual && diaAtual <= +dataFim
    setDataInicioModal(dataInicio)
    setDataFimModal(dataFim)
    setIsDataValida(isValida)

    if (isValida && selectedMovement.flCompAtual) {
      setDataAtuacaoInvalida(false)
    } else {
      setDataAtuacaoInvalida(true) //Tem que por true, coloquei false para criar a nova adequação. 
      if (selectedMovement.flCompAtual) {
        setShowModalAfterLoading(true); // Define o estado para exibir o modal após o carregamento
      }
    }
  }

  const getParamsData = useCallback(async () => {
    try {
      setLoading('loading')
      const responseParams =
        await MovimentacaoMensalServices().getDadosParametrizacao()

      const params = handleResponseParams(responseParams)

      setParamEfetivo(params)
      handleParams(params).then(() => setLoading('idle'))
    } catch (error: any) {
      handleError(error)
    }
  }, [selectedMovement])

  //TODA MOVIMENTACAO TEM QUE BUSCAR O USUARIO PODE
  //ATUAR COMO CONTRAPARTE OU ANALISTA EM CONTRATOS DIFERENTES
  useEffect(() => {
    selectedMovement && getParamsData()
  }, [getParamsData])

  /*
   *
   * PARAMETRIZAÇÂO
   *
   *
   */

  /*
   *
   * GET MOVIMENTAÇÂO
   *
   *
   */

  // Modifique a função verificarConsolidacao
  const verificarConsolidacao = useCallback(async () => {
    try {
      const response = await MovimentacaoMensalServices().getMovimentacao(
        selectedMovement.contratoId,
        competenciaSelecionada
      );

      const valorDataConsolidacao = response.data.entity?.dataConsolidacao;
      if (valorDataConsolidacao !== null) {
        const dataConsolidacao = new Date(valorDataConsolidacao);
        const dataAtual = new Date();
        const consolidacaoFechada = dataConsolidacao <= dataAtual;

        // ✅ Adicione esta linha
        setConsolidacaoFechada(consolidacaoFechada);

        if (consolidacaoFechada && selectedMovement.flCompAtual) {
          setShowModalAfterLoadingConsolidacao(true);
          setDataAtuacaoInvalida(consolidacaoFechada);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar movimentação:", error);
    }
  }, [selectedMovement, competenciaSelecionada, setDataAtuacaoInvalida]);

  useEffect(() => {
    verificarConsolidacao()
  }, [diaAtual, competenciaSelecionada, selectedMovement?.contratoId])


  const getMovDataSemMobilizacao = useCallback(async () => {
    try {
      setIsRequest(true);
      setLoading('loading')
      handleBlock(true, 'visaoTotal')
      setTimeout(() => {
        handleBlock(false, 'visaoTotal')
      }, 500);
      handleBlock(false, 'visaoIndividual')
      // handleBlock(false, 'visaoTotal') 
      const response = await MovimentacaoMensalServices().getMovimentacao(
        selectedMovement.contratoId,
        competenciaSelecionada,
        true//SERVE PARA IDENTIFICAR QUE A MOVIMENTACAO NAO TEM MOBILIZACAO, IGUAL A BRANCH DO ELIAS
      )
      if (!response.data.sucesso && response.data.tipo === 'COMPARTILHANDO') {
        //handleShowErrorList(response.data.mensagem)
        //setLoading('loading')
        getMovData()
        setMovState((prevState) => ({
          ...prevState,
          flStatusMobilizacao: '1'
        }))
      }
      if (response.status !== 200 || !response.data.sucesso) {
        throw new Error(
          response.data.mensagem || 'Não foi possivel obter movimentação.'
        )
      }

      // MOVIMENTACAO 100% NOVA
      if (response.data.sucesso && response.data.entity.movimentacaoId === 0) {
        const responseMovOld =
          await MovimentacaoMensalServices().getCompetenciaAnterior(
            selectedMovement.contratoId,
            competenciaSelecionada,
            true, //IGUAL A branch do elias
            true // Nem precisava, porque setei como true no back, porém para manter a estrutura vou seguir o padrão dos parâmetros do endpoint
          )
        setMovState((old) => ({
          ...old,
          compAnterior: responseMovOld.data.entity,
          compAtual: [],
          flValidAnalista: response.data.entity.flValidAnalista,
          flValidContraparte: response.data.entity.flValidContraparte,
          isCompetenciaAtual: response.data.entity.isCompetenciaAtual,
          movimentacaoId: response.data.entity.movimentacaoId,
          visaoTotal: response.data.entity.visaoTotal
        }))

        // LIBERA FUNCTIONS VISAO INDIVIDUAL
        handleBlock(false, 'visaoIndividual')
        //BLOQUEIA FUNCTIONS NA VISÃO TOTAL
        handleBlock(false, 'visaoTotal')
        //setIsLoading(false)
        setIsRequest(false);
        setLoading('idle')
        return
      }
      setMovState((prevState) => ({
        ...response.data.entity,
        ...(prevState.flStatusMobilizacao && {
          flStatusMobilizacao: prevState.flStatusMobilizacao
        })
      }))
      setLoading('idle')
      setLoading('idle') //PARA SAIR A TELA DE CARREGAMENTO
    } catch (error: any) {
      handleError(error)
    }
    setIsRequest(false);
    setIsLoading(false);
  }, [selectedMovement])

  const getMovData = async (type?: 'flComMob') => {
    try {
      //console.log("Ola vinnao, abriu corretamente");
      setIsRequest(true);
      setLoading('loading')
      // Serve para atualizar os valores em tela caso o usuário
      // resolva trafegar entre as opções de checkbox
      handleBlock(true, 'visaoIndividual')
      handleBlock(true, 'visaoTotal')


      const response = await MovimentacaoMensalServices().getMovimentacao(
        selectedMovement.contratoId,
        competenciaSelecionada
        //true  //comentado igual a branch do Elais
      )
      setIsLoading(false)
      if (response.status !== 200 || !response.data.sucesso) {
        throw new Error(
          response.data.mensagem || 'Não foi possivel obter movimentação.'
        )
      }

      // MOVIMENTACAO 100% NOVA
      if (response.data.sucesso && response.data.entity.movimentacaoId === 0) {
        const responseMovOld =
          await MovimentacaoMensalServices().getCompetenciaAnterior(
            selectedMovement.contratoId,
            competenciaSelecionada,
            //TRUE N EXISTE NA branch do elias
          )
        setIsRequest(false);

        setMovState((old) => ({
          ...old,
          compAnterior: responseMovOld.data.entity,
          compAtual: [],
          flValidAnalista: response.data.entity.flValidAnalista,
          flValidContraparte: response.data.entity.flValidContraparte,
          isCompetenciaAtual: response.data.entity.isCompetenciaAtual,
          movimentacaoId: response.data.entity.movimentacaoId,
          visaoTotal: response.data.entity.visaoTotal
        }))

        //LIBERA FUNCTIONS VISAO INDIVIDUAL
        handleBlock(false, 'visaoIndividual')
        //BLOQUEIA FUNCTIONS VISAO TOTAL
        handleBlock(true, 'visaoTotal')
        setIsLoading(false)
        setLoading('idle')
        //setIsRequest(false);
        return
      }

      if (response.data.entity.compAtual.filter((efetivo) => efetivo.cdStatus.trim() != 'COMPARTILHADO').length == 0 && response.data.entity.compAtual.length > 0) {
        setMovState((prevState) => ({
          ...prevState,
          flStatusMobilizacao: '2'
        }))
        //console.log("status da mobilização " + movState.flStatusMobilizacao);
      }
      const compartilhadosCount = response.data.entity.compAtual.filter(
        (efetivo) => efetivo.cdStatus.trim().toUpperCase() === "COMPARTILHADO"
      ).length;
      response.data.entity.visaoTotal.qtCompartilhado = compartilhadosCount;

      setIsRequest(false)
      handleBlock(false, 'visaoIndividual')

      const incompleteFullView = (response.data?.entity?.visaoTotal ===
        null) as boolean

      if (
        response?.data?.entity?.flStatusMobilizacao === '0' &&
        type !== 'flComMob' &&
        //response?.data?.entity?.visaoTotal !== null &&  TIREI POR CONTA DA BRANCH DO ELIAS
        (response?.data?.entity?.visaoTotal?.txNeJustificativa === '' ||
          response?.data?.entity?.visaoTotal?.txNeJustificativa === null)
      ) {
        getMovDataSemMobilizacao()
        return;
      }

      setMovState((prevState) => ({
        ...response.data.entity,
        ...(prevState.flStatusMobilizacao && {
          flStatusMobilizacao: prevState.flStatusMobilizacao
        })
      }))

      if (incompleteFullView) {
        handleBlock(true, 'visaoTotal')
        setLoading('idle')
        return
      }

      if (
        response?.data?.entity?.flStatusMobilizacao === '0' &&
        type === 'flComMob'
      ) {
        handleBlock(true, 'visaoTotal')
        setLoading('idle')
        return
      }

      if (
        response?.data?.entity?.flStatusMobilizacao === '2' &&
        response?.data?.entity?.cdContratoCompartilhado === null &&
        response?.data?.entity?.movimentacaoId === null &&
        type != 'flComMob'
      ) {
        handleBlock(true, 'visaoIndividual')
        handleBlock(true, 'visaoTotal')
        setLoading('idle')
        return
      }

      setBlockVerifyIndividual(true)
      handleBlock(false, 'visaoTotal')
      setLoading('idle')
      setLoading('idle')

    } catch (error: any) {
      handleError(error)
    }
    setIsLoading(false);

  }

  useEffect(() => {
    setIsLoading(true)
    selectedMovement && getMovData()
  }, [selectedMovement])

  /*
   *
   * GET MOVIMENTAÇÂO
   *
   *
   */

  /*
   *
   * VALIDAR EFETIVOS/COLABORADORES
   *
   *
   */

  const validarSomenteCompartilhado = (efetivo: Entity[]): boolean => {
    let isSomenteCompartilhado = true

    efetivo.map((x) => {
      if (x.cdStatus.trim() !== 'COMPARTILHADO') isSomenteCompartilhado = false
    })

    return isSomenteCompartilhado
  }

  const handleSetVisaoTotal = (visaoTotal: CamposVisaoTotal) => {
    setMovState((prevState) => ({
      ...prevState,
      visaoTotal: {
        ...visaoTotal,
        contratoCompartilhadoId: prevState.visaoTotal?.contratoCompartilhadoId
      }
    }))
  }

  const handleSetCompetenciaAtual = (competenciaAtual: Entity[]) => {
    setMovState((prevState) => ({
      ...prevState,
      compAtual: competenciaAtual
    }))
  }

  const handleShowErrorList = (errorsList: ErrorsList[] | string) => {
    toggleModalErrorsList()
    if (typeof errorsList === 'string')
      setErrorList([{ mensagem: errorsList, flError: true, cdCpfPassaporte: '', name: '', message: errorsList }]);
    else
      setErrorList(errorsList)
    handleBlock(true, 'visaoTotal')
  }

  const handleVerificarEfetivo = () => {
    setLoading('loading')
    const efetivos = movState?.compAtual?.map(({ ...efetivo }: Entity) => ({
      ...efetivo,
      cdCpfPassaporte: FORMAT.unMask(efetivo.cdCpfPassaporte),
      contratoId: String(selectedMovement.contratoId),
      fornecedorId: selectedMovement.fornecedorId,
      idMovEfetivo: 0,
      movimentacaoId: movState?.movimentacaoId,
      nuAnoMesCompetencia: competenciaSelecionada
    }))
    MovimentacaoMensalServices()
      .enviarVisaoIndividual(efetivos)
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(
            response.data.mensagem || 'Não foi possível verficar o efetivo'
          )
        }

        const haveErrors = (response.data.errorList?.length > 0) as boolean
        const haveCriticalErrors = ((): boolean => {
          const haveCriticalErrors = true
          const noCriticalErrors = false

          if (haveErrors) {
            const errors = response.data.errorList?.map(
              (error) => error.flError
            )

            if (errors.includes(haveCriticalErrors)) {
              return haveCriticalErrors
            }
          }

          return noCriticalErrors
        })() as boolean

        if (haveErrors) {
          const errorsList = response.data.errorList
          handleShowErrorList(errorsList)

          if (response.data.compAtual.length > 0) {
            setMovState((prevState) => ({
              ...prevState,
              compAtual: response.data.compAtual.map((efetivo) => ({
                ...efetivo,
                cdCategoria: efetivo.cdCategoria?.trim(),
                cdNacionalidade: efetivo.cdNacionalidade?.trim(),
                cdTipoEfetivo: efetivo.cdTipoEfetivo?.trim(),
                nmColaborador: efetivo.nmColaborador,
                dtDemissao: efetivo.dtDemissao
              }))
            }))
          }
        }
        const isSomenteCompartilhado = validarSomenteCompartilhado(
          movState?.compAtual
        )

        let flMovimentacao = null

        const movEfetivosSemDeletado = response.data.compAtual.filter((efetivo => !efetivo.flDelete))
        if (
          movEfetivosSemDeletado.filter(
            (efetivo) => efetivo.cdStatus.trim().toUpperCase() != 'COMPARTILHADO'
          ).length > 0 &&
          response.data.compAtual.length > 0
        ) {
          setMovState((prevState) => ({
            ...prevState,
            flStatusMobilizacao: '1'
          }))
          flMovimentacao = '1'
          handleChangeMobilizacao('flComMob')
        }
        if (
          movEfetivosSemDeletado.filter(
            (efetivo) => efetivo.cdStatus.trim().toUpperCase() != 'COMPARTILHADO'
          ).length == 0 &&
          response.data.compAtual.length > 0
        ) {
          setMovState((prevState) => ({
            ...prevState,
            qtHeQtd: 0,
            peHeVariacao: 0,
            peNePercVarAtual: 0,
            peValVariacao: 0,
            vlHoraExtras: 0,
            flStatusMobilizacao: '2'
          }))
          flMovimentacao = '2'
        }

        if (movEfetivosSemDeletado.length == 0) {
          setMovState((prevState) => ({
            ...prevState,
            flStatusMobilizacao: '0'
          }))
          flMovimentacao = '0'
          handleChangeMobilizacao('flSemMob')
        }

        if (haveCriticalErrors) {
          setBlockVerifyIndividual(false)
          handleBlock(true, 'visaoTotal')
          setLoading('idle')
          return
        }

        const processarEfetivos = () => {

          handleSetCompetenciaAtual(response.data.compAtual)
          handleSetVisaoTotal(response.data.camposCalculados)

          const efetivosValidos =
            response?.data?.camposCalculados?.qtDemitido + response?.data?.camposCalculados?.qtAtivo

          setMovState((prevState) => ({
            ...prevState,
            compAtual: response.data.compAtual,
            visaoTotal: {
              ...prevState.visaoTotal,
              ...response.data.camposCalculados
            },
            totalEfetivoComDemitidos: efetivosValidos
          }))

          const semMovimentacao = !movState?.movimentacaoId as boolean
          MovimentacaoMensalServices()
            .verificaDuplicados(selectedMovement.contratoId, competenciaSelecionada)
            .then((duplicated) => {


              if (semMovimentacao && duplicated?.data?.entity && duplicated?.data?.entity[0] === 0) {
                handleSalvarEfetivo({
                  action: 'createMov',
                  effectiveUpdated: response.data.compAtual,
                  camposCalculados: response.data.camposCalculados,
                  flMovimentacao: flMovimentacao
                })
              }
              else if (duplicated?.data?.entity && duplicated?.data?.entity[0] === 1) {
                handleSalvarEfetivo({
                  action: 'updateMov',
                  effectiveUpdated: response.data.compAtual,
                  camposCalculados: response.data.camposCalculados,
                  flMovimentacao: flMovimentacao,
                })
              }
              else {
                setIsLoading(false);
                showModal({
                  hideButtonCancel: true,
                  message: 'Alerta de movimentação já existente para este contrato nesta competência, favor verificar.',
                  txtButtonConfirm: 'OK',
                  type: 'error'
                })
              }
            })
        }

        let isAutonomo = false;
        const autonomo = response.data.compAtual.find(efetivo => efetivo.cdTipoEfetivo.trim() === 'Autonomo')
        if (autonomo) {
          //handleShowErrorList(errorList)
          //setBlockVerifyIndividual(true)
          // handleBlock(true, 'visaoTotal')
          isAutonomo = true;
          setIsAutonomo(isAutonomo)
          const errorList = [{
            cdCpfPassaporte: autonomo.cdCpfPassaporte,
            message: 'O colaborador foi informado como Autonomo, está correto? Ressaltamos que autonomos precisam de autorização da Diretoria CSN. Caso o colaborador seja um PJ, deverá ser informado como "Sócio" e caso seja MEI, deverá ser informado como "MEI", favor se atentar.',
            flError: true,
            name: autonomo.nmColaborador
          }]
          handleShowErrorList(errorList)
          setLoading('idle')

          const onSimClick = () => {
            setSimClicked(true)
            setBlockVerifyIndividual(true)
            handleBlock(false, 'visaoTotal')
            processarEfetivos()
          }

          const onNaoClick = () => {
            setSimClicked(false)
            setLoading('idle')
            setBlockVerifyIndividual(false)
            handleBlock(true, 'visaoTotal')
          }

          setModalSimClick(() => onSimClick)
          setModalNaoClick(() => onNaoClick)
          return
        }
        processarEfetivos();
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ?? 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleSalvarEfetivo = ({
    action,
    effectiveUpdated,
    camposCalculados,
    flMovimentacao
  }: {
    action: 'createMov' | 'updateMov'
    effectiveUpdated: Entity[]
    camposCalculados: CamposVisaoTotal
    flMovimentacao: string
  }) => {
    setLoading('loading')

    const actions = {
      createMov: MovimentacaoMensalServices().createMov,
      updateMov: MovimentacaoMensalServices().updateMov
    }

    const { visaoTotal } = movState
    actions[action]({
      movEfetivos: effectiveUpdated?.map(({ ...efetivo }: Entity) => ({
        ...efetivo,
        cdCategoria: efetivo.cdCategoria?.trim(),
        cdCpfPassaporte: FORMAT.unMask(efetivo.cdCpfPassaporte),
        cdNacionalidade: efetivo.cdNacionalidade?.trim(),
        cdStatus: efetivo.cdStatus?.trim().toUpperCase(),
        cdTipoEfetivo: efetivo.cdTipoEfetivo?.trim(),
        contratoId: String(selectedMovement.contratoId),
        fornecedorId: selectedMovement.fornecedorId,
        idMovEfetivo: 0,
        movimentacaoId: movState?.movimentacaoId,
        nuAnoMesCompetencia: competenciaSelecionada
      })),
      movimentacao: {
        cdAnalista: '',
        cdContraparte: '',
        flSalvarVerificar: true,
        idMovimentacao: movState?.movimentacaoId,
        ...(isAnalista && {
          cdAnalista: String(user.IdUsuario),
          dtValidAnalista: moment().toISOString(),
          flValidAnalista: false,
          flValidContraparte: movState?.flValidContraparte
        }),
        ...(isContraparte && {
          cdContraparte: String(user.IdUsuario),
          dtValidContraparte: moment().toISOString(),
          flValidAnalista: movState?.flValidAnalista,
          flValidContraparte: false
        }),
        contratoCompartilhadoId: movState?.contratoCompartilhadoId || visaoTotal?.contratoCompartilhadoId || null,
        contratoId: selectedMovement.contratoId,
        flMovValida: visaoTotal?.flMovValida,
        flStatusMobilizacao: flMovimentacao,
        nuAnoMesCompetencia: competenciaSelecionada,
        peHeVariacao: Number(visaoTotal?.peHeVariacao) || 0,
        peNePercVarAtual: Number(visaoTotal?.peNePercVarAtual) || 0,
        peValVariacao: visaoTotal?.peValVariacao,
        qtAcesso: camposCalculados?.qtAcesso,
        qtAfastado: camposCalculados?.qtAfastado,
        qtAtivo: camposCalculados?.qtAtivo,
        qtAutonomo: camposCalculados?.qtAutonomo,
        qtClt: camposCalculados?.qtClt,
        qtCompartilhado: camposCalculados?.qtCompartilhado,
        qtCooperado: camposCalculados?.qtCooperado,
        qtDemitido: camposCalculados?.qtDemitido,
        qtEstagiario: camposCalculados?.qtEstagiario,
        qtEstrangeiro: camposCalculados?.qtEstrangeiro,
        qtHeNormal: 0, //Number(visaoTotal?.qtHeNormal) || 0,
        qtHeQtd: Number(visaoTotal?.qtHeQtd) || 0,
        qtMei: camposCalculados?.qtMei,
        qtNeAtual: camposCalculados?.qtNeAtual,
        qtSocio: camposCalculados?.qtSocio,
        qtTotalEfetivo: camposCalculados?.qtTotalEfetivo,
        qtTransferido: camposCalculados?.qtTransferido,
        txHeJustificativa: Number(visaoTotal?.qtHeQtd) > (Number(visaoTotal?.qtHeNormal) * 0.2) ? visaoTotal?.txHeJustificativa : null,
        txNeJustificativa: null,
        txSalBaseJustificativa: visaoTotal?.txSalBaseJustificativa,
        usuarioId: user.IdUsuario,
        vlFolhaPagto: 0, // Number(visaoTotal?.vlFolhaPagto) || 0,
        vlHoraExtras: Number(camposCalculados?.vlHoraExtras) || 0,
        vlNeVariacaoAtual: visaoTotal?.vlNeVariacaoAtual || 0,
        vlSalBase: Number(camposCalculados?.vlSalBase) || 0
      }
    })
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(
            response.data.mensagem ?? 'Não foi possivel enviar efetivos'
          )
        }

        const haveVisaoTotal = (response.data.valor.mov !== null) as boolean

        if (haveVisaoTotal) {
          setMovState((prevState) => ({
            ...prevState,
            movimentacaoId: response.data.valor.mov.idMovimentacao
          }))
        }

        setBlockVerifyIndividual(true)
        handleBlock(false, 'visaoTotal')

        showModal({
          hideButtonCancel: true,
          message: 'Visão Total gerada.',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })

        setLoading('idle')
      })
      .catch((error: Error) => {
        handleBlock(true, 'visaoTotal')
        setLoading('idle')

        showModal({
          hideButtonCancel: true,
          message:
            error.message ?? 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  /*
   *
   * VALIDAR EFETIVOS/COLABORADORES
   *
   *
   */

  // if (isLoading) {
  //   setLoading('loading');
  //   //loading && setLoadingMessage("Estamos processando os efetivos. Por favor, aguarde...")
  // }
  // if (loading) {
  //   setLoadingMessage("Estamos processando os efetivos. Por favor, aguarde...")
  // }

  // else {
  //   setLoadingMessage("")
  //   setShowModalAfterLoading(true)
  // }

  useEffect(() => {
    if (isLoading) {
      setLoadingMessage("Estamos processando os efetivos. Por favor, aguarde...");
      setLoading('loading');
    } else {
      //setLoading('idle');
      setIsLoading(false);
    }
  }, [isLoading, setLoadingMessage, loading, dataAtuacaoInvalida, selectedMovement, ShowModalAfterLoadingConsolidacao]);

  useEffect(() => {
    if (showModalAfterLoading && !isLoading) {
      showModal({
        hideButtonCancel: true,
        message: `Somente consulta, a data de atuação expirou ou não iniciou. Dia inicio: ${dataInicioModal} Dia fim: ${dataFimModal}`,
        txtButtonConfirm: 'Fechar',
        type: 'alert',
        handleConfirm: () => {
          setShowModalAfterLoading(false);
          if (ShowModalAfterLoadingConsolidacao) {
            setShowModalAfterLoadingConsolidacao(true);
          }
        }
      });
    }
  }, [showModalAfterLoading, isLoading, dataInicioModal, dataFimModal, ShowModalAfterLoadingConsolidacao]);

  useEffect(() => {
    if (ShowModalAfterLoadingConsolidacao && !showModalAfterLoading && !isLoading) {
      showModal({
        hideButtonCancel: true,
        message: `Somente consulta! A consolidação dessa competência já foi fechada.`,
        txtButtonConfirm: 'Fechar',
        type: 'alert',
        handleConfirm: () => {
          setShowModalAfterLoadingConsolidacao(false);
        }
      });
    }
  }, [ShowModalAfterLoadingConsolidacao, showModalAfterLoading, isLoading]);

  useEffect(() => {
    return () => {
      setLoadingMessage(''); // Limpa a mensagem ao sair da página
    };
  }, [setLoadingMessage]);

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <OrientacaoTemplateButtons />
      <CompetenciaAtual
        getMovData={getMovData}
        getMovDataSemMobilizacao={getMovDataSemMobilizacao}
        isRequest={isRequest}
        consolidacaoFechada={consolidacaoFechada} // Adicione esta prop
      />

      <ModalRelatorioErros
        errorList={errorList}
        showModal={modalErrorsList}
        toggleModal={toggleModalErrorsList}
        {...(setIsAutonomo ? {
          autonomo: isAutonomo,
          onSimClick: modalSimClick,
          onNaoClick: modalNaoClick
        } : {})}
      />

      {movState?.flStatusMobilizacao && !blockIndividualVision && (
        <CompetenciaIndividual
          handleSalvarValidarVisaoIndividual={handleVerificarEfetivo}
        />
      )}
      {!blockTotalVision && (
        <VisaoTotal
          handleTab={handleTab}
          isDataExpirada={!(isDataValida && selectedMovement.flCompAtual)}
          consolidacaoFechada={consolidacaoFechada} //Adicione esta prop

        />
      )}
    </Card>
  )
}

export default React.memo(MovimentacaoMensal)